import { ReactNode } from 'react'
import { cn } from '@/utils/cn'
import type { WorkflowColumn } from '@/types/director'
import { WORKFLOW_COLUMN_COLORS } from '@/types/director'

interface WorkflowColumnProps {
  title: string
  column: WorkflowColumn
  count: number
  children: ReactNode
  emptyText?: string
}

export function WorkflowColumn({ title, column, count, children, emptyText }: WorkflowColumnProps) {
  const borderColor = WORKFLOW_COLUMN_COLORS[column]

  return (
    <div className="flex flex-col">
      <div className={cn('border-l-4 rounded-xl shadow-sm bg-white dark:bg-gray-800 p-3 mb-3', borderColor)}>
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-semibold text-gray-700">{title}</h3>
          <span className="text-xs text-gray-500 bg-gray-200 rounded-full px-2 py-0.5">
            {count}
          </span>
        </div>
      </div>
      <div className="flex-1 space-y-2">
        {count === 0 ? (
          <div className="text-center py-8 text-gray-400 text-sm">
            {emptyText || 'Keine Einträge'}
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  )
}
